// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Container, Form, Button, TextArea } from 'semantic-ui-react'

class Help extends Component {
  state = { activeIndex: 0 }

  handleClick = (e, titleProps) => {
    const { index } = titleProps
    const { activeIndex } = this.state
    const newIndex = activeIndex === index ? -1 : index
    this.setState({ activeIndex: newIndex })
  }
  
  render () {
    // const { activeIndex } = this.state
    return (
      <Container className='div1'>
        <div className='div3 centerX'>
          <div>
            {/* <h2>Help Center</h2>
            <br />
            <Accordion styled>
              <Accordion.Title
                active={activeIndex === 0}
                index={0}
                onClick={this.handleClick}
              >
                <Icon name='dropdown' />
                What is a Webview?
              </Accordion.Title>
              <Accordion.Content active={activeIndex === 0}>
                <div>
                  <p>
                    A “webview” is a browser bundled inside of a mobile
                    application producing what is called a hybrid app. Hybrid
                    apps run inside a native container, and leverage the
                    device’s browser engine (but not the browser) to render the
                    HTML and process the JavaScript locally.
                  </p>
                </div>
              </Accordion.Content>

              <Accordion.Title
                active={activeIndex === 1}
                index={1}
                onClick={this.handleClick}
              >
                <Icon name='dropdown' />
                What do you need in order to build the application?
              </Accordion.Title>
              <Accordion.Content active={activeIndex === 1}>
                <div>
                  <li>Your home page must be ”mobile friendly/responsive"</li>
                  <li>Application icon (512x512 recommended)</li>
                  <li>
                    Your wwebsite must comply with the terms and conditions
                  </li>
                </div>
              </Accordion.Content>

              <Accordion.Title
                active={activeIndex === 2}
                index={2}
                onClick={this.handleClick}
              >
                <Icon name='dropdown' />
                Procedure of application creation
              </Accordion.Title>
              <Accordion.Content active={activeIndex === 2}>
                <div>
                  <li>Fill in the form at our Edit page</li>
                  <li>Make payment with via our third-party gateway</li>
                  <li>Downlaod the application files</li>
                  <li>Submit to Google Play and App Store.</li>
                </div>
              </Accordion.Content>
            </Accordion>
             <br /><br /> */}
            <h4>Questions or feature request?</h4>
            <p>Get in touch</p>
            <br /><br />
            <Form style={{width:'80vh'}}
              enctype='multipart/form-data'
              action='https://getform.io/f/68a50b3f-4810-466b-addc-27465979e137'
              method='POST'
            >
              <Form.Field required>
                <label>Full name</label>
                <input type='text' name='name' />
              </Form.Field>
              <Form.Field required>
                <label>Email address</label>
                <input type='text' name='name' />
              </Form.Field>
              <Form.Field required>
                <label>Message</label>
                <TextArea rows={5} type='text' name='message' />
              </Form.Field>
              <Button size='small' type='submit'>
                Send
              </Button>
            </Form>
          </div>
        </div>
      </Container>
    )
  }
}

export default Help
